import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  dialogContainer: {
    '& .MuiPaper-root': {
      height: '650px',
      maxWidth: '800px',
    },
  },
  topicDialogTabContent: {
    marginTop: 12,
    height: '290px',
  },
  dialogButtonContainer: {
    justifyContent: 'space-between',
  },
  formControl: {
    width: '100%',
    '& .MuiAutocomplete-root .MuiInputBase-input': {
      border: '1px solid #0000003b',
      borderRadius: '8px',
    },
  },
  autocompletePaper: {
    marginBottom: '4px',
    width: '100%',
    maxHeight: '250px',
    overflowY: 'auto',
    height: 'auto !important',
  },
  autocompleteChip: {
    maxHeight: '22px',
  },
  fileUploadContainer: {
    '& .dz-message': {
      padding: '8px',
    },
  },
  fileDownloadContainer: {
    margin: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiButtonBase-root': {
      borderRadius: '8px',
      padding: '5px',
    },
  },
  downloadText: {
    margin: 0,
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  pointer: {
    cursor: 'pointer',
  },
  del_icon: {
    marginLeft: '10px',
    cursor: 'pointer',
  },
  transfomIcon: {
    fontSize: 30,
    cursor: 'pointer',
    padding: '8px',
    transition: '0.2s all ease',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  scrollArea: {
    width: '100%',
  },
  listItem: {
    minHeight: 55,
    padding: '4px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  },
  white_bg: {
    background: '#f2f2f2',
  },
  accordionListContainer: {
    height: '430px',
    borderRadius: '10px',
    border: '1px solid #ccc',
    display: 'flex',
    alignItems: 'center',
  },
  accordionContainer: {
    width: 'inherit',
    height: 'auto !important',
  },
  emptyAccordion: {
    background: '#e8e8e8',
  },
  selectedAccordion: {
    background: '#a8d6ff',
    boxShadow: '0px 0px 4px #00418b',
  },
  accordionHeader: {
    minHeight: '50px !important',
    borderRadius: '8px',
    border: '1px solid #ccc',
    '& .MuiExpansionPanelSummary-content': {
      margin: '0px !important',
    },
    '& > .MuiButtonBase-root': {
      alignSelf: 'flex-start',
    },
  },
  accordionHeadingGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      paddingTop: '18px',
    },
  },
  accordionDetails: {
    padding: '4px !important',
    height: 'fit-content !important',
    width: '100%',
    justifyContent: 'center',
  },
  singleWatchlistGroup: {
    width: '100%',
  },
  textFieldContainer: {
    paddingTop: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'inherit',
  },
  textFieldActions: {
    width: '30%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  successDialogContainer: {
    '& .MuiPaper-root': {
      maxHeight: '550px',
      height: 'auto',
      width: '600px',
      borderRadius: 16,
    },
  },
  successDialog: {
    width: '100%',
    maxHeight: '47%',
    height: 'auto',
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  successDialogScroll: {
    maxHeight: '130px',
  },
  mt_1: {
    marginTop: '10px',
  },
  tickerChip: {
    height: '20px',
    margin: '2px',
    paddingTop: '3px',
  },
  dialogLoader: {
    position: 'absolute',
    left: '48%',
    top: 10,
    lineHeight: 0,
  },
  infoText: {
    color: theme.palette.text.secondary,
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  agGridMain: {
    maxHeight: '270px',
  },
  dzMessage: {
    padding: '8px',
    cursor: 'pointer',
    transition: 'all .2s ease-in-out',
    textAlign: 'center',
    color: '#d1d2db',
    border: '1px dashed #e6e7f1',
    borderRadius: 10,
    backgroundColor: '#f8f9ff',
    fontSize: '15px',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: '#7a7b97',
    },
  },
  dropZoneText: {
    fontSize: '15px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  accordionActionButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
    },
    '& > .MuiButtonBase-root:first-child': {
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '0px',
      },
    },
  },
  watchlistGroupNameChip: {
    borderRadius: 4,
    backgroundColor: '#e0e0e0',
  },
  autocompleteFontSizeForMobile: {
    '& .MuiFormLabel-root': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px',
      },
    },
  },
  formControlLabelFontSize: {
    '& .MuiButtonBase-root': {
      [theme.breakpoints.down('xs')]: {
        paddingRight: '4px',
      },
    },
    '& .MuiFormControlLabel-label': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '10px',
      },
    },
  },
  getCompaniesBtn: {
    '& .MuiButton-label': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '11px',
      },
    },
  },
}));
